export const state = {
  signedDocuments: [],
  loading: false,
  searchQuery: '',
  filters: {
    signatories: [],
    startDate: null,
    endDate: null,
  },
  exportSignedDocumentToImanagePending: false,
  exportSignedDocumentToImanageError: null,
  signedDocumentPendingIds: [],
  signedDocumentError: null,
}
